/* Contact page form (sections/contact-form.liquid). Shopify's native contact form, submitted normally so Shopify's
   hCaptcha keeps working. This adds: friendly field checks (messages from the section settings, linked with
   aria-describedby), a honeypot and a 3-second minimum fill time (a bot gets the normal "thanks" and nothing is sent),
   a 3000-character cap, and it keeps what was typed (and the email for the thank-you line) across the page reload. */
(function () {
  'use strict';
  var KEY = 'lagom_contact';
  var t0 = Date.now();
  function ss(k, v) { try { if (v === undefined) { return sessionStorage.getItem(k); } if (v === null) { sessionStorage.removeItem(k); } else { sessionStorage.setItem(k, v); } } catch (e) { return null; } }
  function start() {
    var form = document.getElementById('ContactForm');
    var done = document.querySelector('[data-contact-done]');
    var saved = {}; try { saved = JSON.parse(ss(KEY) || '{}') || {}; } catch (e) { saved = {}; }
    /* The thank-you line: the address that was sent (the page reloads after posting). */
    function fillEmail(mail) {
      if (!done) { return; }
      var slot = done.querySelector('[data-contact-email]');
      if (slot) { slot.textContent = mail || done.getAttribute('data-fallback') || ''; }
    }
    function reveal() {   /* bring the confirmation into view (below the fixed header) and give it focus for screen readers */
      var r = done.getBoundingClientRect();
      if (r.top < 110 || r.bottom > window.innerHeight) { window.scrollTo(0, Math.max(0, window.pageYOffset + r.top - (window.innerHeight - r.height) / 2)); }
      done.focus({ preventScroll: true });
    }
    if (done && !done.hidden) {   /* after a send: again once the page has loaded (the browser's jump to #ContactForm comes late) */
      fillEmail(saved.email); ss(KEY, null); reveal();
      var again = function () { setTimeout(reveal, 60); };
      if (document.readyState === 'complete') { again(); } else { window.addEventListener('load', again); }
    }
    if (!form || !form.querySelector('[data-contact-fields]')) { return; }
    var fields = form.querySelector('[data-contact-fields]');
    var hp = form.querySelector('[data-contact-hp]');
    var name = form.elements['contact[name]'], email = form.elements['contact[email]'], body = form.elements['contact[body]'];
    var keep = form.querySelectorAll('[data-keep]');
    /* Back with an error: Shopify keeps name/email/message; put back the order number and topic too. */
    if (form.querySelector('[data-contact-alert]')) {
      Array.prototype.forEach.call(keep, function (el) { if (saved[el.name] != null) { el.value = saved[el.name]; } });
      var bad = form.querySelector('[aria-invalid="true"]'); if (bad) { bad.focus(); }
    }
    form.noValidate = true;   /* our own messages instead of the browser bubbles (they stay as the no-JS fallback) */
    function errEl(input) { return document.getElementById(input.id.replace(/^ct-(\w+)-/, 'ct-$1-err-')); }
    function show(input, msg) {
      var e = errEl(input); if (!e) { return; }
      if (msg) { e.textContent = msg; e.hidden = false; input.setAttribute('aria-invalid', 'true'); input.setAttribute('aria-describedby', e.id); }
      else { e.hidden = true; input.removeAttribute('aria-invalid'); input.removeAttribute('aria-describedby'); }
    }
    function check(input) {
      var v = input.value.trim(), e = errEl(input), msg = '';
      if (input === name && !v) { msg = e.getAttribute('data-msg'); }
      if (input === email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { msg = e.getAttribute('data-msg'); }
      if (input === body) { if (v.length < 10) { msg = e.getAttribute('data-msg'); } else if (v.length > 3000) { msg = e.getAttribute('data-msg-long'); } }
      show(input, msg); return !msg;
    }
    [name, email, body].forEach(function (input) {
      input.addEventListener('blur', function () { if (input.value.trim() || input.getAttribute('aria-invalid')) { check(input); } });
      input.addEventListener('input', function () { if (input.getAttribute('aria-invalid')) { check(input); } });
    });
    function fakeDone() {   /* a bot: look exactly like a sent message, send nothing */
      fields.hidden = true; if (done) { fillEmail(email.value.trim()); done.hidden = false; reveal(); }
    }
    var sending = false;
    /* Capture on window: runs before Shopify's own captcha listener, which would otherwise send the form anyway. A
       blocked submit stops there; an allowed one carries on untouched to Shopify. */
    function block(e) { e.preventDefault(); e.stopImmediatePropagation(); }
    window.addEventListener('submit', function (e) {
      if (e.target !== form) { return; }
      if (sending) { block(e); return; }
      if ((hp && hp.value) || Date.now() - t0 < Number(form.getAttribute('data-min-ms') || 3000)) { block(e); fakeDone(); return; }
      var ok = [name, email, body].map(check), first = [name, email, body][ok.indexOf(false)];
      if (first) { block(e); first.focus(); return; }
      var keepVals = { email: email.value.trim() };
      Array.prototype.forEach.call(keep, function (el) { keepVals[el.name] = el.value; });
      ss(KEY, JSON.stringify(keepVals));
      sending = true; var btn = form.querySelector('[type="submit"]'); if (btn) { btn.disabled = true; }
      /* a normal POST: Shopify (and its hCaptcha challenge, if it shows one) takes it from here */
    }, true);
    window.addEventListener('pageshow', function (e) { if (e.persisted) { sending = false; var btn = form.querySelector('[type="submit"]'); if (btn) { btn.disabled = false; } } });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
